import { Union } from "../../../fable-library-js.4.25.0/Types.js";
import { union_type, list_type, class_type, string_type } from "../../../fable-library-js.4.25.0/Reflection.js";
import { Common_GenericOptions__AddProp_ZCC5A61F, Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProps_Z4E55E0BD, Common_GenericOptions__ToReactElement_Z2B8EEFE, Common_parseOptions, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7, Modifier_IModifier_$reflection } from "../../Common.fs.js";
import * as react from "react";
import { keyValueList } from "../../../fable-library-js.4.25.0/MapUtil.js";
import { HTMLAttr } from "../../../Fable.React.9.4.0/Fable.React.Props.fs.js";
import { singleton } from "../../../fable-library-js.4.25.0/List.js";

export class Input_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomClass", "Props", "Name", "Modifiers"];
    }
}

export function Input_Option_$reflection() {
    return union_type("Fulma.Radio.Input.Option", [], Input_Option, () => [[["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

/**
 * Generate <label class="radio"></label>
 */
export function radio(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "radio"), (props, children_1) => react.createElement("label", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <input class="radio" />
 */
export function input(options) {
    return Common_GenericOptions__ToReactElement_Z2B8EEFE(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddProp_ZCC5A61F(result, new HTMLAttr(123, [option.fields[0]]));
        }
    }, "radio", singleton(new HTMLAttr(159, ["radio"]))), (props_1) => react.createElement("input", keyValueList(props_1, 1)));
}

